export default "__VITE_ASSET__CbRW61ih__"